// extracted by mini-css-extract-plugin
export var button = "_ix-0";
export var donut = "_ix-1";
export var donutFill = "_ix-3";
export var donutTrack = "_ix-2";